import axios from 'axios';
import moment from 'moment';

export function calculateCarryOver(user, toNow) {
  const fromStart = moment('2017-01-01').startOf('year').format('yyyy-MM-DD');

  const url = `${process.env.VUE_APP_API_PATH}leaves/CalculateLeaveSummary`;
  const params = {
    userId: user.id,
    from: fromStart,
    to: toNow
  };

  return axios.get(url, { params })
    .then(result => {
      const totalLeavesDifferencePrevYear = result.data.monthlyMaximumLeaves - result.data.leavesAvailed;
      console.log(`CalculateLeaveSummary: ${fromStart} - ${toNow} ${totalLeavesDifferencePrevYear}`);
      return totalLeavesDifferencePrevYear;
    })
    .catch(error => {
      console.error(error);
      if (error.response && error.response.status === 401) {
        throw new Error('Unauthorized');
      }
      throw error;
    });
}